import { useEffect, useState } from 'react';

export default function FloatingActions() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-transform hover:-translate-y-1"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </a>
      )}
    </>
  );
}